// AdminCatalogApi.js
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

const baseQuery = fetchBaseQuery({
  baseUrl: process.env.REACT_APP_STORE_API_URL,
  prepareHeaders: (headers) => {
    const token = localStorage.getItem('authtoken');
    if (token) {
      headers.set('Authorization', `Bearer ${token}`);
    }
    return headers;
  },
});

const baseQueryWithReauth = async (args, api, extraOptions) => {
  let result = await baseQuery(args, api, extraOptions);

  if (result.error && result.error.status === 401) {
    localStorage.removeItem('authtoken');
  }

  return result;
};

export const AdminCatalogApi = createApi({
  reducerPath: 'AdminCatalogApi',
  baseQuery: baseQueryWithReauth,
  tagTypes: ['AdminProducts'],
  endpoints: (builder) => ({

    // ✅ 1. New Product Requests (Pending or Rejected and Not Featured)
    getNewProductRequests: builder.query({
      query: (params) => ({
        url: `/catalog/new-product-requests/`,
        params,
      }),
      providesTags: ['AdminProducts'],
    }),

    // ✅ 2. Get All Products (Admin side)
    getAllProducts: builder.query({
      query: (params) => ({
        url: `/catalog/products/`,
        params,
      }),
      providesTags: ['AdminProducts'],
    }),

    // ✅ ✅ 3. Updated: Approve or Reject Product
    updateProductStatus: builder.mutation({
      query: (payload) => ({
        url: `/catalog/product/status/update/`,
        method: 'POST',
        body: payload,
      }),
      invalidatesTags: ['AdminProducts'],
    }),

  }),
});

// ✅ Export Hooks
export const {
  useGetNewProductRequestsQuery,
  useGetAllProductsQuery,
  useUpdateProductStatusMutation,
} = AdminCatalogApi;
